

angular.module('webcomm').directive('resize', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
    window.addEventListener("resize", registerForResize);

    let timer,
        moveUpAnimation,
        moveDownAnimation;

    function registerForResize() {
        $timeout.cancel(timer);
        timer = $timeout(resizeMain, 20, false);
    }

    return {
        link($scope, element, attrs) {
            $rootScope.$on('timeForResize', function () {
                registerForResize();
            });
        }
    };

    function resizePresenceTable(height) {
        $('#people').height(height);
        $('table.people-table>tbody').height(height - 57); // minus (the header height + 20px margin)
        
        moveUpAnimation = moveUpAnimation || findKeyframesRule("moveUp");
        moveDownAnimation = moveDownAnimation || findKeyframesRule("moveDown");

        // remove the existing 0% and 100% rules
        moveUpAnimation.deleteRule("0%");
        moveUpAnimation.appendRule(`0% {  bottom: -${height}px; }`);

        // remove the existing 0% and 100% rules
        moveDownAnimation.deleteRule("100%");
        moveDownAnimation.appendRule(`100% {  bottom: -${height}px; }`);
    }

    function resizeFeedComments(contentHeight, moduleheadHeight) {
        let feedBottom = $('#feed-bottom');
        let feedBottomMobile = $('#feed-bottom-mobile');

        let bottomHeight = 0;
        bottomHeight += feedBottom.is(':visible') ? feedBottom.outerHeight() : 0;
        bottomHeight += feedBottomMobile.is(':visible') ? feedBottomMobile.outerHeight() : 0;

        let feedMiddleHeight = contentHeight - (moduleheadHeight + bottomHeight);

        $('#feed-comments').height(feedMiddleHeight);
    }

    // we need to find a better way to do all this.
    function resizeMain() {
        let total_height = window.innerHeight;
        let navbar_height = $('.navbar').outerHeight();
        let content_height = total_height - navbar_height;
        let modulehead_height = $('.module-head').outerHeight();
        var popover_screen_height = total_height - 100;

        //$('#content-container').height(content_height);
        $('#groups').height(content_height);
        $('#feed').height(content_height);
        $('#group-items').height(content_height - modulehead_height);
        $('#contact-items').height(content_height - modulehead_height);
        $('#contact-entries').height(content_height - modulehead_height);

        resizeFeedComments(content_height, modulehead_height);

        $('#maps').height(content_height);
        $('#map').height(content_height);
        $('#map-fullscreen').height(content_height);

        $('.google-map').height(content_height);


        resizePresenceTable(content_height / 2.5);

        var popoverElement = $('#activity-popover>.popover-box');

        var popover_height = popoverElement.height();
        if (popover_height > popover_screen_height) {
            $('#activity-popover>.popover-box').css('height', popover_screen_height + 'px');
        }
    };

    // search the CSSOM for a specific -webkit-keyframe rule
    function findKeyframesRule(rule) {
        // gather all stylesheets into an array
        var ss = document.styleSheets;

        // loop through the stylesheets
        for (var i = 0; i < ss.length; ++i) {

            // loop through all the rules
            if (ss[i].cssRules) {
                for (var j = 0; j < ss[i].cssRules.length; ++j) {

                    // find the -webkit-keyframe rule whose name matches our passed over parameter and return that rule
                    if (ss[i].cssRules[j].type == (window.CSSRule.KEYFRAMES_RULE || window.CSSRule.WEBKIT_KEYFRAMES_RULE || window.CSSRule.MOZ_KEYFRAMES_RULE) && ss[i].cssRules[j].name == rule)
                        return ss[i].cssRules[j];
                }
            }
        }

        // rule not found
        return null;
    }
}]);